export function mapDialogSpr(spr = {data: [], loading: false, error: null}) {
    if (Object.prototype.toString.call(spr) === '[object Array]'){
        return {data: spr ?? [], loading: false, error: null}
    }else{
        const [data, loading, error] = Object.values(spr);
        if (data !== undefined && loading !== undefined && error !== undefined)
            return spr;
        else
            return {data: data ?? [], loading: loading ?? false, error: error ?? null}
    }
}
/**
 * @param {Array} spr
 * @param {String} idName
 * @param {Function} tempFunc
 * @param {Function} filter
 * */
export function mapSpr(spr = [], idName = '', tempFunc = () => {return ''}, filter = () => {return {}}) {
    if (spr.length === 0) return spr;
    return spr.map(el => {
        return {value: el[idName], text: tempFunc(el), filter: filter(el) }
    })
}
export function checkBooleanValue(value) {
    return !!(value === true || value === 'true')
}
export function clearValue(el) {
    switch (el.typeVar) {
        case 'string':
            el[el.variable] = '';
            break;
        case 'integer':
            el[el.variable] = '0';
            break;
        case 'float':
            el[el.variable] = '0.0';
            break;
        case 'date':
            el[el.variable] = null;
            break;
        case 'checkbox':
            el[el.variable] = false;
            break;
        default:
            el[el.variable] = false;
            break;
    }
    // if (el.typeVar === 'string')
    //     el[el.variable] = ''
    // else if (el.typeVar === 'integer')
    //     el[el.variable] = '0'
    // else if (el.typeVar === 'float')
    //     el[el.variable] = '0.0'
    // else if (el.typeVar === 'date') {
    //     if (el.typeDate === 'month')
    //         el[el.variable] = null
    //     else
    //         el[el.variable] = null
    // } else {
    //     el[el.variable] = null
    // }
}